import { Calendar } from 'primeng/calendar';
import { Subscription } from 'rxjs';

import { AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DateService } from 'src/app/services/date.service';
import { RaceService } from 'src/app/services/race.service';
import { SettingsService } from 'src/app/services/settings.service';
import { SocketService } from 'src/app/services/socket.service';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-date',
  templateUrl: './date.component.html',
  styleUrls: ['./date.component.scss'],
})
export class DateComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() showDate: boolean;
  public rangeDates: Date[] = [this.dateService.startDate, this.dateService.endDate];
  private _subscription = new Subscription();
  @ViewChild('calendarInput') calendarInput!: Calendar;

  constructor(
    private dateService: DateService,
    private raceService: RaceService,
    public appSettings: SettingsService,
    private socketService: SocketService,
    private authService: AuthService
  ) {

    this.showDate = true;

    this._subscription.add(
      this.dateService.dateAll$.subscribe((date) => {
        this.rangeDates[0] = date;
        this.rangeDates[1] = date;
        this.updateDatesArray();
      })
    );

    this._subscription.add(
      this.dateService.dateEnd$.subscribe((date) => {
        this.rangeDates[1] = date;
        this.updateDatesArray();
      })
    );

    this._subscription.add(
      this.dateService.dateStart$.subscribe((date) => {
        this.rangeDates[0] = date;
        this.updateDatesArray();
      })
    );

    this._subscription.add(
      this.authService.refresh.subscribe(() => {
        this.loadData();
      })
    );
  }

  ngAfterViewInit() {
    this.calendarInput.el.nativeElement.addEventListener('keydown', this.handleKeydown.bind(this));
  }

  handleKeydown(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.loadData();
    }
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }

  public loadData() {
    if (!this.rangeDates || !this.rangeDates[0] || !this.rangeDates[1]) {
      return;
    }
    this.dateService.setStartDate(this.rangeDates[0]);
    this.dateService.setEndDate(this.rangeDates[1]);
    this.raceService.emptyRaceList();
    this.raceService.repeatSource.next(this.rangeDates);
    this.calendarInput?.hideOverlay();
  }

  private updateDatesArray() {
    this.rangeDates = [...this.rangeDates];
  }

  ngOnInit() {
  }

  goToCurrentDay() {
    this.dateService.setAllDate(new Date());
    this.authService.refresh.emit();
  }

  // отладочная функция, нигде не вызывается
  public LOGOUTBYCUID() {
    const cUID = localStorage.getItem('cUID');
    if (!cUID) {
      console.error('LOGOUTBYCUID empty cUID');
      return;
    }
    this.socketService.send('LOGOUTBYCUID', { cUID });
  }
}
